// extracted by mini-css-extract-plugin
export default {"block":"bordered-block_block__CWXUY","row":"bordered-block_row__8GWzK"};